// removed by extract-text-webpack-plugin
module.exports = {"text":"src-scripts-components-DataTable-Cells-Text-__textCell___text","padded":"src-scripts-components-DataTable-Cells-Text-__textCell___padded","highlight":"src-scripts-components-DataTable-Cells-Text-__textCell___highlight","value":"src-scripts-components-DataTable-Cells-Text-__textCell___value","pointer":"src-scripts-components-DataTable-Cells-Text-__textCell___pointer","loading":"src-scripts-components-DataTable-Cells-Text-__textCell___loading"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/DataTable/Cells/Text/textCell.css
// module id = 578
// module chunks = 0